import * as React from 'react';
import { CardCountIndicator } from '../CardCountIndicator/CardCountIndicator';
import { IChecklistsCountIndicatorProps } from './types';
import { CHECKLISTS_TOOLTIP } from '../../wording';

export function ChecklistsCountIndicator({
    active,
    checklistsCount,
    doneChecklistsCount,
    onClick,
}: IChecklistsCountIndicatorProps) {
    return (
        <CardCountIndicator
            active={active}
            icon={'done'}
            tooltip={CHECKLISTS_TOOLTIP}
            onClick={onClick}
        >
            {doneChecklistsCount} / {checklistsCount}
        </CardCountIndicator>
    );
}
